import { useEffect } from "react";
import BlogService from "../Service/BlogService";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const CreateArticle = (prenom, role, type, description) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const createArticleWithImages = async () => {
            try {

                // Step 2: Create the article with the image IDs attached
                await BlogService.postFormateur(prenom, role, type, description);

                navigate("/quisommesnous");
            } catch (error) {
                console.error("Erreur lors de la création de l'article :", error);
            }
        };

        createArticleWithImages();
    }, [prenom, role, type, description, dispatch, navigate]);

    return null; // This component does not render anything
};

export default CreateArticle;